const env = process.env.REACT_APP_NODE_ENV;

let apiUrl = process.env.REACT_APP_API_URL_DEV;
let stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST;

let landingUrl = process.env.REACT_APP_LANDING_URL_DEV;
if (env === 'prod') {
  landingUrl = process.env.REACT_APP_LANDING_URL_PROD;
} else if (env === 'test') {
  landingUrl = process.env.REACT_APP_LANDING_URL_TEST;
}

if (env === 'test') {
  apiUrl = process.env.REACT_APP_API_URL_TEST;
} else if (env === 'prod') {
  apiUrl = process.env.REACT_APP_API_URL_PROD;
}

let webUrl = process.env.REACT_APP_WEB_URL_DEV;
if (env === 'test') {
  webUrl = process.env.REACT_APP_WEB_URL_TEST;
} else if (env === 'prod') {
  webUrl = process.env.REACT_APP_WEB_URL_PROD;
  stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD;
}

let dashboardURL = process.env.REACT_APP_DASHBOARD_URL_DEV;
if (env === 'test') {
  dashboardURL = process.env.REACT_APP_DASHBOARD_URL_TEST;
} else if (env === 'prod') {
  dashboardURL = process.env.REACT_APP_DASHBOARD_URL_PROD;
}

type ConfigType = {
  apiUrl?: string;
  webUrl?: string;
  dashboardURL?: string;
  landingUrl?: string;
  stripePublishableKey?: string;
}

const config : ConfigType = {
  apiUrl,
  webUrl,
  dashboardURL,
  landingUrl,
  stripePublishableKey
}

export default config;
